module.exports = __webpack_public_path__ + "img/muhwahib-dashboard.5a5e93e8.png";